import React from 'react'
import 'react-dates/initialize' // initialise react dates to ensure using stylesheet
import 'react-dates/lib/css/_datepicker.css' // import datepicker styles
import './app.css'
import { BrowserRouter as Router } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider, createMuiTheme, StylesProvider, jssPreset } from '@material-ui/core/styles'
import routes from './pages'
import { AuthProvider } from './modules/security/containers/AuthProvider'
import { AlertProvider } from './modules/alert/containers/AlertProvider'
import { create } from 'jss'
import rtl from 'jss-rtl' 
import { useTranslation } from 'react-i18next'




//configure JSS
const jss = create({
  plugins: [...jssPreset().plugins, rtl()],
});

let theme = createMuiTheme({
  direction: 'ltr',
  palette: {
    primary: {
      main: '#4C9666',
    },
  },
}) 


function App(props) {

  const {t} = useTranslation()

  return (
    <Router>
      <StylesProvider jss={jss}>
      <CssBaseline />
        <ThemeProvider theme={{
          ...theme, 
          direction: document.getElementsByTagName('html')[0].getAttribute('dir'),
          // fontSize: document.getElementsByTagName('html')[0].getAttribute('dir') === 'ltr' ? "26px" : "38px"
          }}>
          <AlertProvider>
            <AuthProvider dir="ltr">{renderRoutes(routes)}</AuthProvider>
          </AlertProvider>
        </ThemeProvider>  
      </StylesProvider>;
      
    </Router>
  )
}

export default App
